<template>
	<div class="">
		<header-vue></header-vue>
		<div class="container-l2">
			<h1 class="h11">终端模板</h1>
			<div class="clear marBottom20">
		  		<div class="fr mr20">
					<el-button @click="addFlag=true"><i class="fa fa-plus"></i> 添加模板 </el-button>
				</div>
		  	</div>		
			<div class="groupList">
				<!-- 点击角色头像修改名称，单击用户查看详情 -->
				<div class="sgroupList" v-for="(item,index) in modelList" :key="index">
					<i class="fa fa-meetup" @click="showChange(item)"></i>
					<span v-text="item.template_name" @click="toDetail(item)"></span>

					<strong class="fr">></strong>
					<span class="delete" @click="showDelete(item)">×</span>
				</div>
			</div>
		</div>		
		<!-- 修改名称 -->
		<el-dialog title="信息框" :visible.sync="modelNameFlag" width="500px">
			<el-form label-width="80px">
				<el-form-item label="模板名称">
					<el-input v-model="edit_template_name" auto-complete="off"></el-input>
				</el-form-item>				
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="modelNameFlag=false">取 消</el-button>
				<el-button type="primary" @click="confirmChange()">确 定</el-button>
			</div>
		</el-dialog>
		<!--删除弹框-->
		<el-dialog title="提示" :visible.sync="removeFlag" width="500px" >
		    <div class="userInfo">
				<p>您确认要删除该模板吗？</p>
			</div>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="removeFlag = false">取 消</el-button>
			    <el-button type="primary" @click="confirmDelete()">确 定</el-button>
			  </div>
		</el-dialog>
		<!-- 新增模板组件 -->
	    <el-dialog title="提示框" :visible.sync="addFlag" width="500px">
		    <set-terminal-model @setByValue="setByValue"></set-terminal-model>
		</el-dialog>
		<!-- 显示加载中 -->
	    <loading v-if="showLoading"></loading>
	</div>  
</template>

<script>
	// 新增模板组件
	import setTerminalModel from '../comss/setTerminalModel';
	export default {
		mounted() {
			this.$nextTick(function(){				
				this.getModelList();
		  	})
		},
		components:{
			setTerminalModel
		},
    	data(){
    		return{
    			modelList:[],
				showLoading: false,
				modelDetailList: {},
				detailFlag: false,
				modelNameFlag: false,
				editModal: {},
				edit_template_name: "",
				removeFlag: false,
				// 编辑终端
				edit_terminal: {},
				edit_terminal_flag: false,
				edit_terminal_remark: "",
				addFlag: false
    		}
    	},
    	methods:{
    		getModelList(){
				this.showLoading = true;
				let valiCodeParams={
					uid:this.getCookie('uid'),
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};
		  		
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/TemplateManage/TemplateShow",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	this.showLoading = false;
		        	if(res.data.code=="200"){
		        		this.modelList = res.data.data || [];
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		//console.log(res.data.msg);
		        	}
		  		});  		
		  		
			},
			// 新增模板子传父
			setByValue(childValue){
				this.getModelList();
				this.addFlag = childValue;
			},
			toDetail(row){
				let routeUrl = this.$router.resolve({
			          path: "/device/terminalModelDevice",
			          query: {
			          	id:row.id,
			          	template_name:row.template_name
			          }
			     });
			     window.open(routeUrl.href, '_blank');			
			},
			showChange(item){
				this.modelNameFlag = true;
				this.editModal = item;
				this.edit_template_name = item.template_name;
			},
			confirmChange(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					id: this.editModal.id,
					template_name: this.edit_template_name,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};		  		
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/TemplateManage/UpdateTemplate",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code=="200"){
						this.modelNameFlag = false;
						this.$message.success(res.data.msg,2000)						
						this.getModelList();
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		this.$message.error(res.data.msg)
		        	}
		  		}); 
			},
			showDelete(item){
				this.removeFlag = true;
				this.editModal = item;
			},
			confirmDelete(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					id: this.editModal.id,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};		  		
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/TemplateManage/TemplateDelete",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code=="200"){
						this.removeFlag = false;
						this.$message.success(res.data.msg,2000)						
						this.getModelList();
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		this.$message.error(res.data.msg)
		        	}
		  		}); 
			},
			// 显示编辑弹框
			showRemark(index,row){
				this.edit_terminal_flag = true;
				this.edit_terminal = row;
			},
			// 确定修改备注
			confirmRemark(){
				let valiCodeParams={
					uid:this.getCookie('uid'),
					id: this.edit_terminal.id,
					remarks: this.edit_terminal_remark,
			  		token:this.getCookie('token'),
			  		time:Date.parse( new Date()),
			  		terminalId:4
		  		};		  		
		  		this.sign2(valiCodeParams);
		  		this.$ajax.post(this.$store.state.domain2+"/admin/TemplateManage/UpdateTemplateDetail",this.$qs.stringify(valiCodeParams),{
		            emulateJSON: true
		        }).then(res=>{
		        	if(res.data.code=="200"){
						this.edit_terminal_flag = false;
						this.detailFlag = false;						
						this.$message.success(res.data.msg,2000)
						this.edit_terminal_remark = "";
		        	}else if(res.data.code==10008){
		        		this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
		        	}else{
		        		this.$message.error(res.data.msg)
		        	}
		  		}); 
			}
			
    	}
   }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/device/terminalModel.vue